import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "lib/api";

export function useCampus({ activo } = {}) {
  const qs = typeof activo === "boolean" ? `?activo=${activo}` : "";
  return useQuery({
    queryKey: ["campus", { activo: typeof activo === "boolean" ? activo : null }],
    queryFn: () => api(`/campus${qs}`),
    staleTime: 60_000,
  });
}

export function useCreateCampus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload) =>
      api("/campus", {
        method: "POST",
        body: JSON.stringify(payload),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["campus"] });
    },
  });
}

export function useDeleteCampus() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api(`/campus/${id}`, { method: "DELETE" }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["campus"] }),
  });
}
